import { gql } from 'urql';

const GetV2ATransfer = gql`
  query GetV2ATransferDetail($input: V2ATransferInput!) {
    v2aTransfer(input: $input) {
      id
      value {
        amount
        formatted
      }
      from {
        first
        last
        initials
        full
      }
      to {
        id
        displayName
        email {
          address
          verified
        }
        phoneNumber
      }
      note
      status
      createdAt
      isCancellable
      details {
        __typename
        items {
          __typename
          id
          title
          description
          ... on V2ATransferDetailItemCustomerName {
            copy
          }
          ... on V2ATransferDetailItemStatus {
            copy
          }
          ... on V2ATransferDetailItemSentOn {
            copy
          }
          ... on V2ATransferDetailItemAccountName {
            copy
          }
          ... on V2ATransferDetailCopyItem {
            copy
          }
        }
      }
    }
  }
`;

export default GetV2ATransfer;
